const EMMI_DOMAIN = "@emmi.com.mx";

// Descargas is for Emmi staff. The backend decides on every request; this only
// keeps the tab out of everyone else's way.
export const isEmmiStaff = (email: string | null | undefined): boolean =>
  !!email && email.trim().toLowerCase().endsWith(EMMI_DOMAIN);
